import { create } from "zustand";

export enum FeedSection {
  home = "home",
  explore = "explore",
}

export interface IFeedVisit {
  path: string;
  locationKey: string;
}

interface IState {
  visits: Partial<Record<FeedSection, IFeedVisit>>;
  setVisit: (section: FeedSection, visit: IFeedVisit) => void;
}

export const useFeedResumeStore = create<IState>(
  (set) => ({
    visits: {},
    setVisit: (section, visit) => {
      set(({ visits }) => ({
        visits: {
          ...visits,
          [section]: visit,
        }
      }));
    },
  }),
);
